/**
 * Created by bartdecorte on 27/04/2017.
 */
const EventEmitter = require('events');
import Password from '../utils/Password';
import Mousetrap from 'mousetrap';
import 'mousetrap/plugins/global-bind/mousetrap-global-bind';
import 'select2/dist/js/select2.full';
import 'jquery';
import 'bootstrap';
import CharacterLimiter from '../utils/CharacterLimiter';
import Swal from 'sweetalert2';
import autosize from 'autosize';
import Cookies from 'js-cookie';
import browserSupport from '../helpers/browserSupport';
import ConfirmActions from '../utils/ConfirmActions';
import ModuleSearch from '../components/search/ModuleSearch';

class Page extends EventEmitter {
  constructor() {
    super();
    this.rootEl = document.documentElement;
    new ConfirmActions();
    Page.checkBrowserSupport();
    Page.tooltips();
    Page.tabHash();
    Page.initializeWebsiteSelector();
    Page.initializeSingleSelects();
    Page.initializeMultiSelects();
    Page.initializePasswordFields();
    Page.initializeCharacterLimiter();
    Page.bindListeners();
    Page.lWindowResized();
    Page.altActions();
    Page.autosize();
    Page.propagateNavigation();
    Page.suggestAlphaIfApplicable();
    Page.loadModuleSearch();
  }

  static bindListeners() {
    let $body = $('body');
    $('input[name="act_as_user"]').on('change', (ev) => {
      return Page.lActAsUserChanged(ev);
    });
    $('.js-website-select').on('change', (ev) => {
      return Page.lWebsiteSelectorChanged(ev);
    });
    $('.input-group.color button').on('click', (ev) => {
      return Page.lColorButtonClick(ev);
    });
    $('[readonly].js-select-on-click').on('click', (ev) =>
      Page.lSelectOnClick(ev)
    );
    $body.on('change', '[data-toggle-element]', (ev) => {
      return Page.lToggleElementChanged(ev);
    });
    $(window)
      .on('hashchange', (ev) => Page.lHashChanged(ev))
      .trigger('hashchange');
    $(window).on('resize', (ev) => Page.lWindowResized(ev));
    $('.nav-link').on('shown.bs.tab', (ev) => {
      Page.autosizeUpdate();
    });
  }

  bindKeys(bindings) {
    for (let key in bindings) {
      if (bindings.hasOwnProperty(key)) {
        let binding = bindings[key];
        let global;
        let callback;

        if (
          typeof binding === 'object' &&
          binding !== null &&
          binding.hasOwnProperty('global')
        ) {
          global = binding.global;
          callback = binding.callback;
        } else {
          global = true;
          callback = binding;
        }

        if (global) {
          Mousetrap.bindGlobal(key, callback);
        } else {
          Mousetrap.bind(key, callback);
        }
      }
    }

    return this;
  }

  static loadModuleSearch() {
    [...document.querySelectorAll('[data-search-type]')].forEach((inputType) => {
      const type = inputType.dataset.searchType;
      new ModuleSearch(type);
    })
  }

  static initializeWebsiteSelector() {
    const select = document.querySelector('.js-website-select');

    if (!select) {
      return;
    }

    const options = {
      containerCssClass: select.getAttribute('class'),
      dropdownAutoWidth: true,
      dropdownCssClass:
        'dropdown-menu dropdown-menu-right dropdown-menu-sm show',
      placeholder: 'Choose a website',
    };
    $(select).select2(options);
  }

  static lActAsUserChanged(ev) {
    let $elt = $(ev.target);
    $elt.parents('form').submit();
  }

  static lWebsiteSelectorChanged(ev) {
    let $elt = $(ev.target);
    $elt.parents('form').submit();
  }

  static lColorButtonClick(ev) {
    let $elt = $(ev.target).is('button')
      ? $(ev.target)
      : $(ev.target)
          .parents('button')
          .first();
    $elt
      .parents('.color')
      .find('input')
      .first()
      .focus();
  }

  static lToggleElementChanged(ev) {
    let $elt = $(ev.target);
    if ($elt.get(0).tagName === 'SELECT') {
      let valueForActiveState = $elt
        .find('option[data-toggle-value]')
        .first()
        .attr('value');
      let active = false;
      if ($elt.val() === valueForActiveState) active = true;

      let $toggledElements = $($elt.data('toggle-element'));
      for (let i = 0; i < $toggledElements.length; i++) {
        let $toggledElement = $($toggledElements[i]);
        if (active && $toggledElement.hasClass('toggled-inactive')) {
          $toggledElement.removeClass('toggled-inactive');
        } else if (!active && !$toggledElement.hasClass('toggled-inactive')) {
          $toggledElement.addClass('toggled-inactive');
        }
      }
    }
  }

  static lWindowResized() {
    if (Page.isEmbedded()) {
      const $document = $(document);
      const data = {
        document: {
          width: $document.outerWidth(),
          height: $document.outerHeight(),
        },
      };
      Page.postMessage('resize', data);
    }
    return true;
  }

  static checkBrowserSupport() {
    browserSupport().check();
  }

  static tabHash() {
    $('[data-tabs] a').click((ev) => {
      let $elt = $(ev.target).is('a')
        ? $(ev.target)
        : $(ev.target)
            .parents('a')
            .first();
      $elt.tab('show');
      let $li = $elt.parents('li').first();
      let $container = $li.parents('.nav-tabs').first();
      $container.find('li.active').removeClass('active');
      $li.addClass('active');
      let scrollmem = $('body').scrollTop() || $('html').scrollTop();
      window.location.hash = $elt.attr('href');
      $('html,body').scrollTop(scrollmem);
    });

    let hash = window.location.hash;
    hash && $('.nav-link[role="tab"][href="' + hash + '"]').trigger('click');
  }

  static lHashChanged() {
    let hash = window.location.hash;
    let $elt = $('.modal' + hash);
    if ($elt.length) {
      let $body = $('body');
      let $trigger = $(
        '<a href="' + hash + '" data-toggle="modal" style="display: none;"></a>'
      );
      $body.append($trigger);
      $trigger.trigger('click');
      $trigger.detach();
    }
    return true;
  }

  static tooltips() {
    const tooltips = document.querySelectorAll('[data-toggle="tooltip"]');
    $(tooltips).tooltip();
  }

  static initializeSingleSelects() {
    const selectEls = document.querySelectorAll('.single-select');
    let placeholder = 'Choose an option';

    selectEls.forEach((el) => {
      const options = {
        containerCssClass: el.getAttribute('class'),
        dropdownAutoWidth: true,
        dropdownCssClass:
          'dropdown-menu dropdown-menu-right dropdown-menu-sm show',
        placeholder: el.dataset.placeholder
          ? el.dataset.placeholder
          : placeholder,
      };

      $(el).select2(options);
    });
  }

  static initializeMultiSelects() {
    const selects = document.querySelectorAll('.multi-select[multiple]');

    selects.forEach((select) => {
      // select.style.width = 'auto';
      $(select).select2({
        placeholder: 'Choose one or more options',
        containerCssClass: select.getAttribute('class'),
        // dropdownAutoWidth: true,
        dropdownCssClass: 'dropdown-menu dropdown-menu-right show',
      });

      /*if (select.classList.contains('w-100')) {
        select.nextSibling.style.width = '100%';
      }*/
    });
  }

  static initializePasswordFields() {
    let $elements = $('.input-group.js-password');
    for (let i = 0; i < $elements.length; i++) {
      new Password({
        $element: $($elements[i]),
      });
    }
  }

  static lSelectOnClick(ev) {
    const $input = $(ev.target);
    $input.select();
    return true;
  }

  static isEmbedded() {
    return esign.info.embedded;
  }

  static postMessage(type, data) {
    window.parent.postMessage(
      {
        type,
        data,
      },
      '*'
    );
  }

  static propagateNavigation() {
    if (Page.isEmbedded()) {
      const {
        hash,
        host,
        hostname,
        href,
        origin,
        pathname,
        port,
        protocol,
        search,
      } = window.location;
      const data = {
        pageTitle: esign.info.pageTitle,
        breadcrumbs: esign.info.breadcrumbs,
        location: {
          hash,
          host,
          hostname,
          href,
          origin,
          pathname,
          port,
          protocol,
          search,
        },
      };
      Page.postMessage('navigation', data);
    }
    return this;
  }

  static initializeCharacterLimiter() {
    new CharacterLimiter();
  }

  static altActions() {
    const $body = $('body');
    const cssClass = 'alt-pressed';
    Mousetrap.bind(
      'alt',
      () => {
        if (!$body.hasClass(cssClass)) {
          $body.addClass(cssClass);
        }
      },
      'keydown'
    );
    Mousetrap.bind(
      'alt',
      () => {
        if ($body.hasClass(cssClass)) {
          $body.removeClass(cssClass);
        }
      },
      'keyup'
    );
  }

  static shouldSuggestAlpha() {
    return (
      window.esign.info.alpha.shouldSuggest && !Cookies.get('alpha_dismissed')
    );
  }

  static alphaUrl() {
    return window.esign.info.alpha.location;
  }

  static suggestAlpha() {
    Swal.fire({
      title: 'Please use alpha 🥺',
      text: `We're continuously making improvements to Unleash. Please head over to the internal test environment and help us to push fewer bugs to production.`,
      icon: 'info',
      showCancelButton: true,
      cancelButtonText: 'No thanks',
      confirmButtonText: 'Take me there',
      customClass: {
        confirmButton: 'btn ml-1 mr-1 btn-primary',
        cancelButton: 'btn ml-1 mr-1 btn-light',
      },
      buttonsStyling: false,
    }).then(({ isConfirmed, isDismissed }) => {
      if (isConfirmed) {
        window.location = Page.alphaUrl();
      } else {
        Cookies.set('alpha_dismissed', 'true', { expires: 1 });
        Swal.close();
      }
    });
  }

  static suggestAlphaIfApplicable() {
    if (Page.shouldSuggestAlpha()) {
      setTimeout(() => {
        Page.suggestAlpha();
      }, 1000);
    }
  }

  static autosizeElements() {
    return document.querySelectorAll('[data-toggle="autosize"]');
  }

  static autosize() {
    autosize(Page.autosizeElements());
  }

  static autosizeUpdate() {
    autosize.update(Page.autosizeElements());
  }

  keyBindings() {
    return {
      w: {
        global: false,
        callback: () => {
          $('.js-website-select').select2('open');
        },
      },
      s: {
        global: false,
        callback: (e) => {
          e.preventDefault();
          $('.js-module-search').focus();
        },
      }
    };
  }
}

export default Page;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Page.js